<template>
  <section class="find-tutor rounded-section">
    <div class="container relative h-[200px]">
      <img
        src="/front-img/start-teaching/polkadot.svg"
        width="241"
        height="264"
        alt="polkadot"
        class="svg__polkadot"
      >
      <img
        src="/front-img/start-teaching/stars.svg"
        width="116"
        height="132"
        alt="stars"
        class="svg__stars"
      >
      <img
        src="/front-img/start-teaching/waves.svg"
        width="252"
        height="84"
        alt="waves"
        class="svg__waves"
      >
      <div class="find-tutor__wrapper">
        <p class="find-tutor__title">
          {{ findTutorTitle }}
        </p>
        <BaseButton shadow classes="lg:w-[335px] w-full mt-8 mx-auto" size="sm-lg" @click="findClicked">
          <div class="flex items-center justify-center">
            <BaseIcon
              name="teacher"
              color="text-white"
              type="custom"
              custom-size="w-6 h-6 mx-0"
            />
            <span
              class="text__button-link-sm--bold lg:text__button-link-lg--bold  ml-2"
            >{{ $t('actions.find_best_tutor') }}</span>
          </div>
        </BaseButton>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import staticData from './static-data'

export default {
  name: 'WorldFindTutor',
  components: {
  },
  data () {
    return {
      ...staticData
    }
  },
  methods: {
    ...mapActions('authentication', ['saveActionAfterLogin']),
    findClicked () {
      if (!this.$auth.loggedIn) {
        this.saveActionAfterLogin({ type: 'redirect', target: this.$routes.tutor_request_course.name })
        this.$nuxt.$emit('AuthDialogLogin')
      } else {
        this.$router.push(this.localePath({
          name: this.$routes.tutor_request_course.name
        }))
      }
    }
  }
}
</script>

<style scoped lang="scss">
.find-tutor {
  @apply bg-primary-50 h-[194px] lg:h-[200px];
  &__wrapper {
    @apply text-center py-10 lg:py-12 absolute z-10 mx-auto left-4 lg:left-0 right-4 lg:right-0 h-full;
  }
  &__title {
    @apply text__body-2-xs--semibold lg:text__headline-5-md--bold mb-2 lg:mb-4 text-primary-700;
  }
  .svg {
    &__polkadot {
      @apply absolute left-4 lg:left-0 top-[70px] lg:top-4 w-[96px] lg:w-auto;
    }
    &__waves {
      @apply absolute right-0 bottom-4 z-0 lg-block-hidden;
    }
    &__stars {
      @apply absolute right-4 lg:right-[60px] bottom-[60px] w-[71px] lg:w-auto;
    }
  }
}
</style>
